import * as React from 'react';
import Button from '../Button/Button';
import classnames from 'classnames';

interface YesNoBtnsProps {
  onYes?: () => void;
  onNo?: () => void;
  yesLabel?: string;
  noLabel?: string;
  selected?: 'yes' | 'no' | '';
  order?: ['yes', 'no'] | ['no', 'yes'];
  icons?: React.ReactNode[];
  isOutlined?: boolean;
  yesBtnClass?: string;
  noBtnClass?: string;
}
const YesNoBtns: React.SFC<YesNoBtnsProps> = (props) => {
  const {
    onYes,
    onNo,
    selected,
    yesLabel = 'Yes',
    noLabel = 'No',
    order = ['no', 'yes'],
    icons = [],
    isOutlined,
    yesBtnClass = '',
    noBtnClass = '',
  } = props;
  return (
    <div className="columns is-mobile">
      <>
        {
          order.map((type, idx) => (
            <div key={idx} className="column">
              <Button

                onClick={type === 'yes' ? onYes : onNo}
                color={selected === type ? 'primary' : ''}
                className={classnames(
                  'is-capitalized is-rounded is-small',
                  {
                    'is-outlined': isOutlined,
                    [yesBtnClass]: yesBtnClass && type === 'yes',
                    [noBtnClass]: noBtnClass && type === 'no'
                  }
                )}
              >
                {
                  !!icons.length &&
                  <span>{icons[idx]}&nbsp;&nbsp;</span>
                }
                {type === 'yes' ? yesLabel : noLabel}
              </Button>
            </div>
          ))
        }
        <div className="column">

        </div>
      </>
    </div>
  )
}

export default YesNoBtns;